export class CurrencyConverter {
    public convert(amount: number, from: Currency, to: Currency) {
        const fromFactor = this.unitInEuro(from)
        const toFactor = this.unitInEuro(to)
        return amount * fromFactor / toFactor
    }

    public convertPrice(from: Price, to: Currency) {
        const fromFactor = this.unitInEuro(from.unit)
        const toFactor = this.unitInEuro(to)
        return from.value * fromFactor / toFactor
    }

    private unitInEuro (unit: Currency) {
        switch (unit) {
            case "euro": return 1
            case "dollar": return 1.03
            case "pound": return 1.12
            default: return 1
        }
    }
}
